<div class="heading">
    <span class="title">Beschrijving gebruikersrollen</span>
    <span class="ui-help">Een gebruiker kan meerdere rollen hebben. De meest uitgebreide rechten zijn van toepassing.</span>
</div>
<div class="roles">
    @for (role of roles; track role.key) {
        @let active = !!selected?.includes(role.key);
        <div [class.active]="active" class="role">
            <i [class.fa-circle-check]="active" [class.fa-circle]="!active" [class.fa-solid]="active" [class.fa-regular]="!active" class="state"></i>
            <span class="text">
                <span class="name">{{ role.name }}</span>
                @if (role.description) {
                    <span class="description">{{ role.description }}</span>
                }
                @if (role.restricted) {
                    <span class="restricted">Alleen toe te kennen door Codalt</span>
                }
            </span>
        </div>
    }
</div>
